// Copyright (C) 2021 Bystronic Laser AG

import { AlertAction, WccAlertMetric, AlertOperator } from './enums/AlertsEnums';

export class WccAlert {
  static GetEmpty(): WccAlert {
    return new WccAlert(
      null,
      0,
      null,
      WccAlertMetric.None,
      AlertOperator.None,
      0,
      AlertAction.None,
      [],
    );
  }

  static GetCopy(original: WccAlert): WccAlert {
    return new WccAlert(
      original.id,
      original.tenantId,
      original.deviceId,
      original.metric,
      original.operator,
      original.threshold,
      original.action,
      original.recipients,
      original.deviceName,
      original.tenantName,
    );
  }

  constructor(
    public id: number | null,
    public tenantId: number | null,
    public deviceId: number | null,
    public metric: WccAlertMetric,
    public operator: AlertOperator,
    public threshold: number,
    public action: AlertAction | null,
    public recipients: number[],
    // Received when requesting an alerts list
    public deviceName?: string,
    // Received when requesting an alerts list
    public tenantName?: string,
  ) {}
}
